/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule`
 */
export interface ApiDataRulePostRequest {
  /**
   * 数值规则id
   */
  id?: number;
  /**
   * 数值规则名称
   */
  name?: string;
  /**
   * 属性组Id
   */
  dataPropertyGroupId?: number;
  /**
   * 模板类型 1:数值型；2：解析型
   */
  type?: 1 | 2;
  /**
   * 说明
   */
  detail?: string;
  /**
   * 是否保存。true:保存；false：草稿。
   */
  save?: boolean;
  /**
   * 步骤
   */
  step?: number;
  /**
   * 属性类型 2表示瞬时 1 表示累积
   */
  propertyType?: 1 | 2;
  /**
   * 数据点周期. 1:天，2：星期；3：年
   */
  dataPointPeriod?: number;
  /**
   * 数据点间隔。1：1min;2:15min;3：30min;4:1h;5:2h;6:6h;7:12h;8:24h
   */
  dataPointInterval?: number;
  /**
   * 数据点数值,通过excel导入
   */
  excelKey?: string;
  /**
   * Y轴倍率名称
   */
  yMagnificationName?: string;
  /**
   * Y轴倍率默认值
   */
  yMagnificationValue?: number;
  /**
   * 累计量算累积量倍率
   */
  magnificationCumulative?: number;
  /**
   * 累积量起始值名称
   */
  cumulativeStartName?: string;
  /**
   * 累积量起始值默认值
   */
  cumulativeStartValue?: number;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule`
 */
export type ApiDataRulePostResponse = number;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule`
 */
type ApiDataRulePostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule',
    'retdata',
    string,
    string,
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule`
 */
const apiDataRulePostRequestConfig: ApiDataRulePostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRulePost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `POST /api/data-rule`
 */
export const apiDataRulePost = /*#__PURE__*/ (requestData: ApiDataRulePostRequest, ...args: UserRequestRestArgs) => {
  return request<ApiDataRulePostResponse>(prepare(apiDataRulePostRequestConfig, requestData), ...args);
};

apiDataRulePost.requestConfig = apiDataRulePostRequestConfig;

/* prettier-ignore-end */
